import React from 'react';
import { Card, Badge } from '@/components/ui';
import type { PlanRevenueData } from '../../types/dashboard.types';

interface PlanStatusTableProps {
  plans: PlanRevenueData[];
}

export function PlanStatusTable({ plans }: PlanStatusTableProps) {
  return (
    <Card className="p-6 border-slate-100 shadow-sm col-span-1 lg:col-span-1 flex flex-col h-[320px]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-medium text-slate-900">Gói dịch vụ theo trạng thái</h3>
        <button className="sm:text-sm text-xs font-medium text-emerald-600 hover:text-emerald-700">Xem tất cả</button>
      </div>
      
      <div className="flex-1 overflow-auto scrollbar-none">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-slate-100">
              <th className="py-3 font-medium text-slate-500 sm:text-sm text-xs">Gói dịch vụ</th>
              <th className="py-3 font-medium text-slate-500 sm:text-sm text-xs text-center">Tổ chức</th>
              <th className="py-3 font-medium text-slate-500 sm:text-sm text-xs text-right">Doanh thu (VNĐ)</th>
              <th className="py-3 font-medium text-slate-500 sm:text-sm text-xs text-right">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {plans.map((item, idx) => (
              <tr key={idx} className="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                <td className="py-3 sm:text-sm text-xs font-medium text-slate-700">{item.name}</td>
                <td className="py-3 sm:text-sm text-xs font-medium text-slate-900 text-center">{item.tenants}</td>
                <td className="py-3 sm:text-sm text-xs font-medium text-slate-600 text-right">{(item.value || 0).toFixed(2)} tỷ</td>
                <td className="py-3 text-right">
                  {item.status === 'active' ? (
                    <Badge variant="custom" className="bg-emerald-50 text-emerald-600 border-emerald-100 px-2 py-0.5 sm:text-sm text-xs">
                      Hoạt động
                    </Badge>
                  ) : (
                    <Badge variant="custom" className="bg-slate-50 text-slate-500 border-slate-200 px-2 py-0.5 sm:text-sm text-xs">
                      Dùng thử
                    </Badge>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
